/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramGeoUserControllerResolveCityMutationRequest,
  TelegramGeoUserControllerResolveCityMutationResponse,
  TelegramGeoUserControllerResolveCity401,
} from '../../types/TelegramGeoUserControllerResolveCity.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramGeoUserResolveCity } from '../../methods/telegramGeoUserResolveCity.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramGeoUserResolveCityMutationKey = () => [{ url: '/api/user/telegram/geo/resolve-city' }] as const;

export type TelegramGeoUserResolveCityMutationKey = ReturnType<typeof telegramGeoUserResolveCityMutationKey>;

/**
 * {@link /api/user/telegram/geo/resolve-city}
 */
export function useTelegramGeoUserResolveCity<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramGeoUserControllerResolveCityMutationResponse,
      ResponseErrorConfig<TelegramGeoUserControllerResolveCity401>,
      { data?: TelegramGeoUserControllerResolveCityMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramGeoUserControllerResolveCityMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramGeoUserResolveCityMutationKey();

  return useMutation<
    TelegramGeoUserControllerResolveCityMutationResponse,
    ResponseErrorConfig<TelegramGeoUserControllerResolveCity401>,
    { data?: TelegramGeoUserControllerResolveCityMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramGeoUserResolveCity(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
